// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n5Qf","col":"styles_col__1ai9A"};